import React, { useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { useCallback } from "react";
import { getAllMenu } from "../../../api/menuApi";
import { createRole, getRoleById, updateRoleById } from "../../../api/roleApi";
import { getRoleManagementByRoleId } from "../../../api/roleManagementApi";
import { Button } from "@material-ui/core";

const RoleFormPage = ({ id, handleCloseModalForm }) => {
    // const { id } = useParams();
    const history = useHistory();
    const controllerRef = useRef(null);

    // component state
    const [namerole, setNameRole] = useState("");
    const [statusrole, setStatusRole] = useState(true);
    const [menus, setMenus] = useState([]);

    const getData = useCallback(
        async signal => {
            if (id === undefined) {
                const data_menu = await getAllMenu(signal);
                const mock_menus = [];
                data_menu.map(async mock_menu => {
                    await mock_menus.push({
                        name: mock_menu?.menuControlName,
                        menuID: mock_menu?.id,
                        pmAll: false,
                        pmView: false,
                        pmInsert: false,
                        pmUpdate: false,
                        pmDelete: false,
                        menuLv1Index: mock_menu?.menuControlMainSub,
                        menuLv2Index: mock_menu?.menuControlIndex,
                    });
                    return null;
                });
                setMenus(mock_menus);
            } else {
                const role_by_id = await getRoleById(id, controllerRef.current?.signal);
                await setNameRole(role_by_id?.roleName);
                await setStatusRole(role_by_id?.status?.toString());

                const role_management = await getRoleManagementByRoleId(id);
                const data_menu = await getAllMenu(signal);
                const mock_menus = [];
                data_menu.map(async mock_menu => {
                    const edit_view = role_management?.filter(
                        x => x?.menuId === mock_menu?.id && x?.permissionAccess === 1,
                    );
                    const edit_insert = role_management?.filter(
                        x => x?.menuId === mock_menu?.id && x?.permissionAccess === 2,
                    );
                    const edit_update = role_management.filter(
                        x => x?.menuId === mock_menu?.id && x?.permissionAccess === 3,
                    );
                    const edit_delete = role_management.filter(
                        x => x?.menuId === mock_menu?.id && x?.permissionAccess === 4,
                    );
                    let edit_all = false;
                    if (
                        edit_view[0]?.status &&
                        edit_insert[0]?.status &&
                        edit_update[0]?.status &&
                        edit_delete[0]?.status
                    ) {
                        edit_all = true;
                    }

                    await mock_menus.push({
                        name: mock_menu?.menuControlName,
                        menuID: mock_menu?.id,
                        pmAll: edit_all,
                        pmView: edit_view[0]?.status,
                        pmInsert: edit_insert[0]?.status,
                        pmUpdate: edit_update[0]?.status,
                        pmDelete: edit_delete[0]?.status,
                        pmViewID: edit_view[0]?.id,
                        pmInsertID: edit_insert[0]?.id,
                        pmUpdateID: edit_update[0]?.id,
                        pmDeleteID: edit_delete[0]?.id,
                        menuLv1Index: mock_menu?.menuControlMainSub,
                        menuLv2Index: mock_menu?.menuControlIndex,
                    });
                    return null;
                });
                setMenus(mock_menus);
            }
        },
        [id],
    );

    useEffect(() => {
        controllerRef.current = new AbortController();
        const fetch = async () => {
            getData(controllerRef.current?.signal);
        };
        fetch();
        return () => {
            controllerRef.current.abort();
        };
    }, [getData]);

    const onChangeNameRole = e => {
        try {
            setNameRole(e.target.value);
        } catch (error) {
            console.log(error);
        }
    };

    const onChangeStatusRole = e => {
        try {
            console.log(e.target.value);
            setStatusRole(e.target.value === "true" ? true : false);
        } catch (error) {
            console.log(error);
        }
    };

    const clickSubmit = async e => {
        try {
            e.preventDefault();
            if (namerole === "") {
                Swal.fire({
                    heightAuto: false,
                    icon: "error",
                    title: "Error!",
                    text: "Please specify user rights name.",
                    confirmButtonColor: "#3085d6",
                });
            } else {
                if (id) {
                    // edit mode
                    const { isConfirmed } = await Swal.fire({
                        title: "Do you want to edit user permission groups?",
                        text: "If sure, press OK.",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "OK",
                        cancelButtonText: "CANCEL",
                        allowOutsideClick: false,
                    });
                    if (isConfirmed) {
                        const roleManagement = [];
                        menus.forEach(item => {
                            const permission = [
                                {
                                    id: item?.pmViewID,
                                    menuId: item?.menuID,
                                    permissionAccess: 1,
                                    status: item?.pmView || false,
                                },
                                {
                                    id: item?.pmInsertID,
                                    menuId: item?.menuID,
                                    permissionAccess: 2,
                                    status: item?.pmInsert || false,
                                },
                                {
                                    id: item?.pmUpdateID,
                                    menuId: item?.menuID,
                                    permissionAccess: 3,
                                    status: item?.pmUpdate || false,
                                },
                                {
                                    id: item?.pmDeleteID,
                                    menuId: item?.menuID,
                                    permissionAccess: 4,
                                    status: item?.pmDelete || false,
                                },
                            ];
                            roleManagement.push(...permission);
                        });
                        const updateBody = {
                            roleName: namerole,
                            status: statusrole,
                            roleManagement,
                        };
                        const isUpdate = await updateRoleById(id, updateBody, controllerRef.current?.signal);
                        if (isUpdate) {
                            // history.replace("/user_role_management/role_list");
                            history.go(0);
                            
                        }
                    }
                } else {
                    // create mode
                    const { isConfirmed } = await Swal.fire({
                        title: "Would you like to add a user permission group?",
                        text: "If sure, press OK.",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "OK",
                        cancelButtonText: "CANCEL",
                        allowOutsideClick: false,
                    });
                    if (isConfirmed) {
                        const roleManagement = [];
                        menus.forEach(item => {
                            const permission = [
                                { menuId: item?.menuID, permissionAccess: 1, status: item?.pmView || false },
                                { menuId: item?.menuID, permissionAccess: 2, status: item?.pmInsert || false },
                                { menuId: item?.menuID, permissionAccess: 3, status: item?.pmUpdate || false },
                                { menuId: item?.menuID, permissionAccess: 4, status: item?.pmDelete || false },
                            ];
                            roleManagement.push(...permission);
                        });
                        const createBody = {
                            roleName: namerole,
                            status: statusrole,
                            roleManagement,
                        };
                        const isCreate = await createRole(createBody, controllerRef.current?.signal);
                        if (isCreate) {
                            history.replace("/user_role_management/role_list");
                        }
                    }
                }
            }
        } catch (error) {
            console.dir(error);
        }
    };

    // const clickCancel = async () => {
    //     history.replace("/user_role_management/role_list");
    // };

    const selectAllData = (e, data) => {
        const dataMock = [...menus];
        const indexForEdit = dataMock.findIndex(x => {
            return x?.menuID === data?.menuID;
        });
        dataMock[indexForEdit] = {
            ...dataMock[indexForEdit],
            menuID: data?.menuID,
            name: data?.name,
            pmAll: e.target.checked,
            pmDelete: e.target.checked,
            pmInsert: e.target.checked,
            pmUpdate: e.target.checked,
            pmView: e.target.checked,
        };
        setMenus(dataMock);
    };

    const selectViewData = (e, data) => {
        const dataMock = [...menus];
        const indexForEdit = dataMock.findIndex(x => {
            return x?.menuID === data?.menuID;
        });
        if (e.target.checked === false && data?.menuID === 0) {
            dataMock[indexForEdit] = {
                ...dataMock[indexForEdit],
                menuID: data?.menuID,
                name: data?.name,
                pmAll: false,
                pmDelete: data?.pmDelete,
                pmInsert: data?.pmInsert,
                pmUpdate: data?.pmUpdate,
                pmView: e.target.checked,
            };
        } else if (e.target.checked === true && data?.menuID === 0) {
            dataMock[indexForEdit] = {
                ...dataMock[indexForEdit],
                menuID: data?.menuID,
                name: data?.name,
                pmAll: true,
                pmDelete: data?.pmDelete,
                pmInsert: data?.pmInsert,
                pmUpdate: data?.pmUpdate,
                pmView: e.target.checked,
            };
        } else if (
            data.menuID !== 0 &&
            (e.target.checked === false ||
                data?.pmInsert === false ||
                data?.pmUpdate === false ||
                data?.pmDelete === false)
        ) {
            dataMock[indexForEdit] = {
                ...dataMock[indexForEdit],
                menuID: data?.menuID,
                name: data?.name,
                pmAll: false,
                pmDelete: data?.pmDelete,
                pmInsert: data?.pmInsert,
                pmUpdate: data?.pmUpdate,
                pmView: e.target.checked,
            };
        } else if (
            data?.menuID !== 0 &&
            e.target.checked === true &&
            data?.pmInsert === true &&
            data?.pmUpdate === true &&
            data?.pmDelete === true
        ) {
            dataMock[indexForEdit] = {
                ...dataMock[indexForEdit],
                menuID: data?.menuID,
                name: data?.name,
                pmAll: true,
                pmDelete: data?.pmDelete,
                pmInsert: data?.pmInsert,
                pmUpdate: data?.pmUpdate,
                pmView: e.target.checked,
            };
        } else {
            dataMock[indexForEdit] = {
                ...dataMock[indexForEdit],
                menuID: data?.menuID,
                name: data?.name,
                pmAll: data?.pmAll,
                pmDelete: data?.pmDelete,
                pmInsert: data?.pmInsert,
                pmUpdate: data?.pmUpdate,
                pmView: e.target.checked,
            };
        }

        setMenus(dataMock);
    };

    const selectCreateData = (e, data) => {
        const dataMock = [...menus];
        const indexForEdit = dataMock.findIndex(x => {
            return x?.menuID === data?.menuID;
        });

        if (
            data?.menuID !== 0 &&
            (e.target.checked === false ||
                data?.pmView === false ||
                data?.pmUpdate === false ||
                data?.pmDelete === false)
        ) {
            dataMock[indexForEdit] = {
                ...dataMock[indexForEdit],
                menuID: data?.menuID,
                name: data?.name,
                pmAll: false,
                pmDelete: data?.pmDelete,
                pmInsert: e.target.checked,
                pmUpdate: data?.pmUpdate,
                pmView: data?.pmView,
            };
        } else if (
            data?.menuID !== 0 &&
            e.target.checked === true &&
            data?.pmView === true &&
            data?.pmUpdate === true &&
            data?.pmDelete === true
        ) {
            dataMock[indexForEdit] = {
                ...dataMock[indexForEdit],
                menuID: data?.menuID,
                name: data?.name,
                pmAll: true,
                pmDelete: data?.pmDelete,
                pmInsert: e.target.checked,
                pmUpdate: data?.pmUpdate,
                pmView: data?.pmView,
            };
        } else {
            dataMock[indexForEdit] = {
                ...dataMock[indexForEdit],
                menuID: data?.menuID,
                name: data?.name,
                pmAll: data?.pmAll,
                pmDelete: data?.pmDelete,
                pmInsert: e.target.checked,
                pmUpdate: data?.pmUpdate,
                pmView: data?.pmView,
            };
        }
        setMenus(dataMock);
    };

    const selectEditData = (e, data) => {
        const dataMock = [...menus];
        const indexForEdit = dataMock.findIndex(x => {
            return x?.menuID === data?.menuID;
        });
        if (
            data?.menuID !== 0 &&
            (e.target.checked === false ||
                data?.pmView === false ||
                data?.pmInsert === false ||
                data?.pmDelete === false)
        ) {
            dataMock[indexForEdit] = {
                ...dataMock[indexForEdit],
                menuID: data?.menuID,
                name: data?.name,
                pmAll: false,
                pmDelete: data?.pmDelete,
                pmInsert: data?.pmInsert,
                pmUpdate: e.target.checked,
                pmView: data?.pmView,
            };
        } else if (
            data?.menuID !== 0 &&
            e.target.checked === true &&
            data?.pmView === true &&
            data?.pmInsert === true &&
            data?.pmDelete === true
        ) {
            dataMock[indexForEdit] = {
                ...dataMock[indexForEdit],
                menuID: data?.menuID,
                name: data?.name,
                pmAll: true,
                pmDelete: data?.pmDelete,
                pmInsert: data?.pmInsert,
                pmUpdate: e.target.checked,
                pmView: data?.pmView,
            };
        } else {
            dataMock[indexForEdit] = {
                ...dataMock[indexForEdit],
                menuID: data?.menuID,
                name: data?.name,
                pmAll: data?.pmAll,
                pmDelete: data?.pmDelete,
                pmInsert: data?.pmInsert,
                pmUpdate: e.target.checked,
                pmView: data?.pmView,
            };
        }
        setMenus(dataMock);
    };

    const selectDeleteAndCancelData = (e, data) => {
        const dataMock = [...menus];
        const indexForEdit = dataMock.findIndex(x => {
            return x?.menuID === data?.menuID;
        });
        if (
            data?.menuID !== 0 &&
            (e.target.checked === false ||
                data?.pmView === false ||
                data?.pmInsert === false ||
                data?.pmUpdate === false)
        ) {
            dataMock[indexForEdit] = {
                ...dataMock[indexForEdit],
                menuID: data?.menuID,
                name: data?.name,
                pmAll: false,
                pmDelete: e.target.checked,
                pmInsert: data?.pmInsert,
                pmUpdate: data?.pmUpdate,
                pmView: data?.pmView,
            };
        } else if (
            data?.menuID !== 0 &&
            e.target.checked === true &&
            data?.pmView === true &&
            data?.pmInsert === true &&
            data?.pmUpdate === true
        ) {
            dataMock[indexForEdit] = {
                ...dataMock[indexForEdit],
                menuID: data?.menuID,
                name: data?.name,
                pmAll: true,
                pmDelete: e.target.checked,
                pmInsert: data?.pmInsert,
                pmUpdate: data?.pmUpdate,
                pmView: data?.pmView,
            };
        } else {
            dataMock[indexForEdit] = {
                ...dataMock[indexForEdit],
                menuID: data?.menuID,
                name: data?.name,
                pmAll: data?.pmAll,
                pmDelete: e.target.checked,
                pmInsert: data?.pmInsert,
                pmUpdate: data?.pmUpdate,
                pmView: data?.pmView,
            };
        }
        setMenus(dataMock);
    };

    return (
        <div className="row">
            <div className="col-12 mb-2">
                <div className="card-header">
                    <div className="card-title">Add User Rights Group</div>
                    <div className="card-body" style={{ padding: 11 }}>
                        <div className="row">
                            <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <div className="form-group">
                                    <label>
                                        User Rights Name<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Please specify user rights name."
                                        onChange={onChangeNameRole}
                                        value={namerole}
                                    />
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <div className="form-group">
                                    <label>Status</label>
                                    <select className="form-control" onChange={onChangeStatusRole} value={statusrole}>
                                        <option value="true">open</option>
                                        <option value="false">close</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Permissions</th>
                                            <th>All</th>
                                            <th>View</th>
                                            <th>Create</th>
                                            <th>Edit</th>
                                            <th>Delete/Cancel</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {menus.map((menu, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        <div className={menu?.menuLv2Index > 0 ? "ml-5" : ""}>
                                                            {menu?.menuLv2Index > 0 ? "-" : ""} {menu?.name}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="checkbox-list">
                                                            <label className="checkbox checkbox-lg">
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={e => selectAllData(e, menu)}
                                                                    checked={menu?.pmAll}
                                                                />
                                                                <span></span>
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="checkbox-list">
                                                            <label className="checkbox checkbox-lg">
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={e => selectViewData(e, menu)}
                                                                    checked={menu?.pmView}
                                                                />
                                                                <span></span>
                                                            </label>
                                                        </div>
                                                    </td>
                                                    {menu?.menuID !== 0 ? (
                                                        <>
                                                            <td>
                                                                <div className="checkbox-list">
                                                                    <label className="checkbox checkbox-lg">
                                                                        <input
                                                                            type="checkbox"
                                                                            onChange={e => selectCreateData(e, menu)}
                                                                            checked={menu?.pmInsert}
                                                                        />
                                                                        <span></span>
                                                                    </label>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="checkbox-list">
                                                                    <label className="checkbox checkbox-lg">
                                                                        <input
                                                                            type="checkbox"
                                                                            onChange={e => selectEditData(e, menu)}
                                                                            checked={menu?.pmUpdate}
                                                                        />
                                                                        <span></span>
                                                                    </label>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="checkbox-list">
                                                                    <label className="checkbox checkbox-lg">
                                                                        <input
                                                                            type="checkbox"
                                                                            onChange={e =>
                                                                                selectDeleteAndCancelData(e, menu)
                                                                            }
                                                                            checked={menu?.pmDelete}
                                                                        />
                                                                        <span></span>
                                                                    </label>
                                                                </div>
                                                            </td>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                        </>
                                                    )}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row mt-15">
                            <div className="col-12">
                                <center>
                                    <Button
                                        type="reset"
                                        className="btn t-btn-primary mr-10"
                                        style={{ width: "100px" }}
                                        onClick={clickSubmit}>
                                        SAVE
                                    </Button>
                                    <Button
                                        type="reset"
                                        className="btn t-btn-gray"
                                        style={{ width: "100px" }}
                                        onClick={handleCloseModalForm}>
                                        CANCEL
                                    </Button>
                                </center>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RoleFormPage;
